/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';
import UIInputStaticLabel from 'UIComponents/input/UIInputStaticLabel';
import UINumberInput from 'UIComponents/input/UINumberInput';
import DateTime from 'ContentComponents/cmv2/fields/DateTime';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { DATE_TIME } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT, STEP } from 'DesignData/enums/CustomWidgetFieldAttributes';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

export default class _class extends PureComponent {
  constructor(...args) {
    super(...args);

    this.onStepChange = e => {
      const value = e.target.value;

      if (!isNaN(value) && value > 0) {
        this.props.editField({
          [STEP]: value
        });
      }
    };

    this.onDefaultChange = value => {
      this.props.editField({
        [DEFAULT]: value
      });
    };
  }

  render() {
    const {
      field,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(ToolFormControl, {
        label: I18n.text(i18nKey(`defaultLabels.${DATE_TIME}`)),
        children: /*#__PURE__*/_jsx(SidebarInput, {
          inputComponent: DateTime,
          onFieldChange: this.onDefaultChange,
          step: field[STEP],
          type: field.type,
          value: field[DEFAULT],
          readOnly: readOnly
        })
      }), /*#__PURE__*/_jsx(ToolFormControl, {
        label: I18n.text(i18nKey('datetime.step')),
        tooltip: I18n.text(i18nKey('datetime.stepTooltip')),
        tooltipPlacement: "left",
        children: /*#__PURE__*/_jsx(UIInputStaticLabel, {
          position: "end",
          text: I18n.text(i18nKey('datetime.minutes')),
          children: /*#__PURE__*/_jsx(SidebarInput, {
            inputComponent: UINumberInput,
            onChange: this.onStepChange,
            value: field[STEP],
            disabled: readOnly
          })
        })
      })]
    });
  }

}
_class.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  readOnly: PropTypes.bool
};